import { AppRouteProps } from "@bsm/component";
import ProjectCalendarDetailsAppointmentContainer from "./container/ProjectCalendarDetailsAppointmentContainer";
import { ProjectEventEditRoutes } from "./views/edit/ProjectEventEditRoutes";

export const ProjectCalendarCardDetailsRoutes: Array<AppRouteProps> = [
    {
        path: ":id",
        title: "{{TimeOffTitle}}",
        element: <ProjectCalendarDetailsAppointmentContainer />,
        roles: ["TIMEOFF"],
        children: [
            ...ProjectEventEditRoutes
        ]
    },
];
